import { render, staticRenderFns } from "./SelectableParticipant.vue?vue&type=template&id=2d16a6e2&scoped=true"
import script from "./SelectableParticipant.vue?vue&type=script&lang=js"
export * from "./SelectableParticipant.vue?vue&type=script&lang=js"
import style0 from "./SelectableParticipant.vue?vue&type=style&index=0&id=2d16a6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16a6e2",
  null
  
)

export default component.exports